import React, { useState, useEffect } from 'react';
import { Play, ArrowLeft, Menu, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import NavigationMenu from './NavigationMenu';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const TrailerPage = ({ isHomePage = false }) => {
  const navigate = useNavigate();
  const [playing, setPlaying] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [youtubeId, setYoutubeId] = useState('AXywaVTAMac');

  useEffect(() => {
    fetch(`${API_URL}/api/movie`)
      .then(r => r.json())
      .then(d => {
        if (d.trailerUrl) {
          const match = d.trailerUrl.match(/(?:embed\/|watch\?v=|youtu\.be\/)([^?&]+)/);
          if (match) setYoutubeId(match[1]);
        }
      })
      .catch(() => {});
  }, []);

  const thumbnailUrl = `https://img.youtube.com/vi/${youtubeId}/maxresdefault.jpg`;

  return (
    <div className="fixed inset-0 bg-black" data-testid="trailer-page">
      {/* Header overlay */}
      <header className={`fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-6 py-4 transition-opacity duration-500 ${playing ? 'opacity-0 pointer-events-none' : 'opacity-100'}`}>
        <button
          onClick={() => setMenuOpen(true)}
          className="w-12 h-12 rounded-full bg-[#50c878] flex items-center justify-center hover:bg-[#40a0a0] transition-colors"
          data-testid="menu-button"
        >
          <Menu className="w-6 h-6 text-white" />
        </button>
        {!isHomePage && (
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-white/60 hover:text-white transition-colors font-condensed tracking-wider text-sm uppercase"
            data-testid="back-button"
          >
            <ArrowLeft className="w-4 h-4" /> Volver
          </button>
        )}
      </header>

      <NavigationMenu isOpen={menuOpen} onClose={() => setMenuOpen(false)} />

      {/* Fullscreen Video / Thumbnail */}
      {playing ? (
        <>
          <iframe
            className="absolute inset-0 w-full h-full z-10"
            src={`https://www.youtube.com/embed/${youtubeId}?autoplay=1&rel=0&modestbranding=1&controls=1&fs=1`}
            title="Los Legendarios - Trailer Oficial"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
            allowFullScreen
            frameBorder="0"
          />
          {/* Close button */}
          <button
            onClick={() => setPlaying(false)}
            className="fixed top-6 right-6 z-50 w-12 h-12 rounded-full bg-black/60 backdrop-blur-sm flex items-center justify-center hover:bg-black/80 transition-colors"
            data-testid="close-trailer"
          >
            <X className="w-6 h-6 text-white" />
          </button>
        </>
      ) : (
        <div className="absolute inset-0 flex items-center justify-center">
          {/* Background thumbnail */}
          <img
            src={thumbnailUrl}
            alt="Trailer thumbnail"
            className="absolute inset-0 w-full h-full object-cover"
          />
          {/* Overlay */}
          <div className="absolute inset-0 bg-black/50" />

          {/* Center content */}
          <div className="relative z-10 flex flex-col items-center gap-8">
            <p className="font-condensed text-sm text-[#50c878] tracking-[0.3em] uppercase">
              Trailer Oficial
            </p>

            {/* Logo image instead of text */}
            <img
              src="/images/logo_titulo.png"
              alt="Los Legendarios"
              className="w-[300px] sm:w-[450px] lg:w-[600px] object-contain drop-shadow-2xl"
              data-testid="trailer-logo"
            />

            {/* Play Button */}
            <button
              onClick={() => setPlaying(true)}
              className="group relative w-24 h-24 sm:w-32 sm:h-32 mt-4"
              data-testid="play-trailer-button"
            >
              {/* Glow ring */}
              <div className="absolute inset-0 rounded-full bg-[#50c878]/20 animate-ping" style={{ animationDuration: '2s' }} />
              {/* Border ring */}
              <div className="absolute inset-0 rounded-full border-2 border-white/30 group-hover:border-[#50c878] transition-colors duration-300" />
              {/* Inner circle */}
              <div className="absolute inset-2 rounded-full bg-white/10 backdrop-blur-sm group-hover:bg-[#50c878]/30 transition-all duration-300 flex items-center justify-center">
                <Play className="w-10 h-10 sm:w-14 sm:h-14 text-white fill-white ml-1" />
              </div>
            </button>

            <p className="font-condensed text-xs text-white/40 tracking-[0.2em] uppercase mt-4">
              En Cines 15 de Mayo 2026
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default TrailerPage;
